import { useEffect, useState } from "react";
import { loadPublicSiteConfig, siteDisplayNameFromLoadedConfig } from "./publicSiteConfigLoader";

export type PublicSiteDisplayNameState = {
	ready: boolean;
	siteDisplayName: string | null;
};

/**
 * Libellé verticale (`sites.label` via `display_name`) depuis le cache `loadPublicSiteConfig`.
 * À utiliser sur les écrans publics hors StepEmail lorsque les drapeaux d’intégration ne sont pas nécessaires.
 */
export function usePublicSiteDisplayName(): PublicSiteDisplayNameState {
	const [state, setState] = useState<PublicSiteDisplayNameState>({ ready: false, siteDisplayName: null });

	useEffect(() => {
		let cancelled = false;
		void loadPublicSiteConfig().then((cfg) => {
			if (!cancelled) {
				setState({
					ready: true,
					siteDisplayName: siteDisplayNameFromLoadedConfig(cfg),
				});
			}
		});
		return (): void => {
			cancelled = true;
		};
	}, []);

	return state;
}
